import  { type DayOfEmergencyDto } from "@crowdcoursing/api/openapi";

/** Mirrors API `DayOfEmergencySchoolwideStatusRequestSummaryDto` (add to generated types after OpenAPI regen). */
export interface LastSchoolwideStatusRequestSummary {
  requestedAtUtc: string;
  requestedByUserId?: string | null;
  requestedByLawEnforcementUserId?: string | null;
  requesterFirstName?: string | null;
  requesterLastName?: string | null;
}

/** Reads optional field from day payload until the OpenAPI client includes `lastSchoolwideStatusRequest`. */
export function readLastSchoolwideStatusRequest(day: DayOfEmergencyDto): LastSchoolwideStatusRequestSummary | null {
  const extended = day as DayOfEmergencyDto & {
    lastSchoolwideStatusRequest?: LastSchoolwideStatusRequestSummary | null;
  };
  return extended.lastSchoolwideStatusRequest ?? null;
}

function formatLocalDateTime(iso: string | undefined): string {
  if (!iso) {
    return "—";
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  return d.toLocaleString(undefined, {
    dateStyle: "short",
    timeStyle: "medium",
  });
}

export function formatSchoolwideRequesterDisplayName(summary: LastSchoolwideStatusRequestSummary): string {
  const first = summary.requesterFirstName?.trim() ?? "";
  const last = summary.requesterLastName?.trim() ?? "";
  const name = [first, last].filter(Boolean).join(" ").trim();
  if (name) {
    return name;
  }
  if (summary.requestedByLawEnforcementUserId) {
    return "Law enforcement contact";
  }
  if (summary.requestedByUserId) {
    return "User";
  }
  return "Unknown";
}

/** Single sentence for ECC / history UI. */
export function formatLastSchoolwideStatusRequestSummary(summary: LastSchoolwideStatusRequestSummary): string {
  const when = formatLocalDateTime(summary.requestedAtUtc);
  const who = formatSchoolwideRequesterDisplayName(summary);
  return `Last requested ${when} by ${who}.`;
}
